module.exports = __webpack_public_path__ + "fonts/c0d3c94cd6112550c51d7d1ed13b9da1.eot";